<template>
  <div class="ai-chat-panel">
    <div class="ai-chat-header">
      <span class="ai-chat-header-title">{{ title || "新对话" }}</span>
      <button
        type="button"
        class="ai-collapse-btn"
        :title="collapsed ? '展开历史对话' : '收起历史对话'"
        @click="$emit('toggle-collapse')"
      >
        <i :class="collapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
      </button>
    </div>

    <div ref="scroller" class="ai-chat-body">
      <div v-if="!messages.length" class="ai-chat-empty">
        <i class="el-icon-cpu ai-empty-icon"></i>
        <p class="ai-empty-title">你好，我是小盟 AI</p>
        <p class="ai-empty-sub">{{ currentHint }}</p>
        <div class="ai-empty-tips">
          <span v-for="tip in tips" :key="tip" class="ai-tip" @click="$emit('send', { input: tip })">
            {{ tip }}
          </span>
        </div>
      </div>

      <message-item
        v-for="m in messages"
        :key="m._key"
        :message="m"
        @resend="$emit('resend', $event)"
      />
    </div>

    <chat-input
      :mode="mode"
      :sending="sending"
      :disabled="disabled"
      @send="$emit('send', $event)"
      @update:mode="$emit('update:mode', $event)"
      @attach="$emit('attach')"
    />
  </div>
</template>

<script>
import MessageItem from "./MessageItem.vue";
import ChatInput from "./ChatInput.vue";
import { AI_MODES } from "../api/aiApi";

export default {
  name: "ChatPanel",
  components: { MessageItem, ChatInput },
  props: {
    mode: { type: String, required: true },
    messages: { type: Array, default: () => [] },
    sending: { type: Boolean, default: false },
    title: { type: String, default: "" },
    collapsed: { type: Boolean, default: false },
    // AI 服务不可用或刚被上游限流时置 true，向下透传给输入区
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tipsMap: {
        consult: ["我们公司想给中层管理者做一次领导力培训", "想给销售团队做一次实战训练，怎么安排？"],
        recommend: ["金融行业新员工入职培训，预算 5 万以内", "有没有讲数字化转型的老师？"],
        search: ["要找擅长银行网点营销的老师", "沟通技巧类课程，2 天，面向支行行长"],
      },
    };
  },
  computed: {
    modeMeta() {
      return AI_MODES.find((m) => m.value === this.mode) || AI_MODES[0];
    },
    currentHint() {
      return this.modeMeta.hint;
    },
    tips() {
      return this.tipsMap[this.mode] || [];
    },
  },
  watch: {
    // 新消息上屏后滚到底部
    messages() {
      this.scrollToBottom();
    },
    mode() {
      this.scrollToBottom();
    },
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.scroller;
        if (el) el.scrollTop = el.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.ai-chat-panel {
  flex: 1;
  min-width: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.ai-chat-header {
  flex: 0 0 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid #f2f3f5;
  box-sizing: border-box;
}

.ai-chat-header-title {
  font-size: 16px;
  font-weight: 600;
  color: #1d2129;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ai-collapse-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid #e5e6eb;
  background: #fff;
  color: #4e5969;
  cursor: pointer;
}

.ai-collapse-btn:hover {
  background: #f7f8fa;
}

.ai-chat-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px 24px;
  background: #fff;
}

.ai-chat-empty {
  text-align: center;
  padding: 60px 20px;
}

.ai-empty-icon {
  font-size: 40px;
  color: #409eff;
}

.ai-empty-title {
  font-size: 18px;
  color: #1d2129;
  margin: 14px 0 6px;
}

.ai-empty-sub {
  font-size: 13px;
  color: #86909c;
  margin: 0 0 24px;
}

.ai-empty-tips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.ai-tip {
  font-size: 13px;
  color: #4e5969;
  background: #f7f8fa;
  border: 1px solid #e5e6eb;
  border-radius: 16px;
  padding: 6px 14px;
  cursor: pointer;
}

.ai-tip:hover {
  border-color: #409eff;
  color: #409eff;
}
</style>
